import React from "react";
import VideoPlayer from "components/VideoPlayer";
import AudioPlayer from "components/AudioPlayer";
import ImageContainer from "components/ImageContainer/ImageContainer";
import MediaPreview from "components/MediaPreview/MediaPreview";
import PlaceholderWithBGFilled from "assets/img/Placeholder_with_BG_filled.svg";

const PollMediaContent = ({ media_type, media, mediaCaptions }) => {
  return (
    <div>
      {media_type === 4 && <AudioPlayer src={media} />}
      {media_type === 3 && (
        <VideoPlayer
          src={media || ""}
          style={{ borderRadius: "25px", overflow: "hidden" }}
          mediaCaptions={mediaCaptions}
        />
      )}
      {media_type === 2 && (
        <MediaPreview attachment={media || ""}  type={"image"}>
          <ImageContainer src={media || ""} thumb={media || ""} alt={"Media"} />
        </MediaPreview>
      )}
      {media_type === 1 && (
        <ImageContainer
          src={PlaceholderWithBGFilled}
          thumb={PlaceholderWithBGFilled}
          alt={"Text"}
        />
      )}
    </div>
  );
};
export default PollMediaContent;
